import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class OkIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          fillRule='evenodd'
          d='M7.002,14.005 C3.131,14.005 -0.008,10.873 -0.008,7.010 C-0.008,3.147 3.131,0.015 7.002,0.015 C10.874,0.015 14.013,3.147 14.013,7.010 C14.013,10.873 10.874,14.005 7.002,14.005 ZM11.676,4.291 C11.265,3.880 10.599,3.880 10.189,4.291 L5.926,8.554 L4.640,7.269 C4.261,6.890 3.647,6.890 3.268,7.269 C2.890,7.647 2.890,8.261 3.268,8.640 L5.266,10.637 C5.277,10.649 5.280,10.664 5.291,10.676 C5.394,10.779 5.513,10.856 5.640,10.907 C5.764,10.959 5.896,10.984 6.028,10.983 C6.300,10.984 6.572,10.883 6.779,10.676 L11.676,5.778 C12.087,5.368 12.087,4.702 11.676,4.291 Z'
          transform='translate(1 1)'/> ]
  getViewBox = () => '0 0 16 16'
}
